module.exports = __webpack_public_path__ + "static/media/Hallway.94c69f5b.glb";